import { Rectangle } from 'recharts';
import type { ComponentProps } from 'react';

import { colorForSeries } from '../shared/chart-palette';
import { resolveFallbackFill } from '../shared/chart-helpers';
import { CHART_BAR_FALLBACK, CHART_DIMENSIONS } from '../shared/chart-tokens';

type RectangleProps = ComponentProps<typeof Rectangle>;

export interface BarChartHorizontalBarProps extends RectangleProps {
  value: number | null;
  seriesIndex: number;
  seriesCount: number;
}

/** Rounds the value-end (right) corners for horizontal bars. */
const BAR_RADIUS: [number, number, number, number] = [
  0,
  CHART_DIMENSIONS.barCornerRadius,
  CHART_DIMENSIONS.barCornerRadius,
  0,
];

export const BarChartHorizontalBar = (props: BarChartHorizontalBarProps) => {
  const { value, seriesIndex, seriesCount, ...rectangleProps } = props;
  const { width, height, x } = rectangleProps;

  if (width === undefined || height === undefined || x === undefined) {
    return null;
  }

  if (value === null || value === 0) {
    const thickness = CHART_BAR_FALLBACK.thicknessPx;
    const { fill, fillOpacity } = resolveFallbackFill(
      value,
      seriesIndex,
      seriesCount
    );

    return (
      <Rectangle
        {...rectangleProps}
        width={thickness}
        fill={fill}
        fillOpacity={fillOpacity}
        radius={BAR_RADIUS}
      />
    );
  }

  if (width === 0 || height === 0) {
    return null;
  }

  const fill = colorForSeries(seriesIndex, seriesCount);

  return <Rectangle {...rectangleProps} fill={fill} radius={BAR_RADIUS} />;
};
